import React from 'react'
import dayjs from 'dayjs'
import {
  AnalyticsContext,
  AnalyticsFilterDefaultValues,
  AnalyticsFilterType
} from '../AnalyticsContext'
import { useAnalyticsFilterFromQuery } from './useAnalyticsFilterFromQuery'
import {
  DateFilterType,
  useDateFilterContext,
  WithDateFilterContext
} from '../../../components/common/dateFilter'
import { AnalyticsFilterWithGroups } from '../../../graphql/private/PrivateSchemaTypes'

type WithAnalyticsContextProps = {
  // pass
}

const getFilterWithQueryVariablesTypes = (
  filter: AnalyticsFilterType,
  dateFilter: DateFilterType
): AnalyticsFilterWithGroups => ({
  includeAdmins: filter.includeAdmins,
  includeArchived: filter.includeArchived,
  includeDrafts: filter.includeDrafts,
  topicId: filter.topicId,
  userId: filter.userId,
  workspaceIds: filter.workspaceIds
    ? filter.workspaceIds.map((value) => Number(value))
    : null,
  pathwayIds: filter.pathwayIds
    ? filter.pathwayIds.map((value) => Number(value))
    : null,
  groupIds: filter.groupIds
    ? filter.groupIds.map((value) => Number(value))
    : null,
  from: dayjs(dateFilter.from).startOf('day').toISOString(),
  to: dayjs(dateFilter.to).endOf('day').toISOString()
})

const WithAnalyticsContextComponent: React.FC<WithAnalyticsContextProps> = ({
  children
}) => {
  const [filter, changeFilter] = useAnalyticsFilterFromQuery()
  const [dateFilter, changeDateFilter] = useDateFilterContext()

  const filterAsQueryVariables = React.useMemo(
    () => getFilterWithQueryVariablesTypes(filter, dateFilter),
    [filter, dateFilter]
  )

  return (
    <AnalyticsContext.Provider
      value={{
        filter,
        changeFilter,
        changeDateFilter,
        filterAsQueryVariables
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  )
}

export const WithAnalyticsContext: React.FC = ({ children }) => {
  return (
    <WithDateFilterContext defaultValues={AnalyticsFilterDefaultValues}>
      <WithAnalyticsContextComponent>{children}</WithAnalyticsContextComponent>
    </WithDateFilterContext>
  )
}
